module.exports = __webpack_public_path__ + "img/fig10.74f0b520.jpg";